<template>
  <svg :width="width" :height="height" viewBox="0 0 18 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g transform="translate(-52, -1253)"> <g transform="translate(52, 1253)"> <path d="M4,0 L18,0 L18,0 L18,10 C18,12.209139 16.209139,14 14,14 L0,14 L0,14 L0,4 C0,1.790861 1.790861,4.4408921e-16 4,0 Z" class="st0"></path> <path d="M9.5,4.09861218 L12.9342585,9.25 L6.06574145,9.25 L9.5,4.09861218 Z" class="st1" stroke="#664E06" fill="#664E06" stroke-linejoin="round" transform="translate(9.5, 6.875) scale(-1, 1) rotate(-90) translate(-9.5, -6.875)"></path> </g> </g> </g> </svg>
</template>

<script>

export default {
  props: {
    width: {
      type: Number,
      default: 18
    },
    height: {
      type: Number,
      default: 14
    }
  }
}
</script>

<style lang="scss" scoped>
.st0 {
  fill:#333;
}

.st1 {
  fill:#FFCA27;
  stroke:#FFCA27;
}

[data-mode="light"] {
  .st0 {
    fill: #FEF0C4;
  }

  .st1 {
    fill: #664E06;
    stroke: #664E06;
  }
}
</style>